import * as Yup from "yup";

export const JobApplicationSchema = Yup.object({
  first_name: Yup.string().trim().required("The first name field is required.").matches(
    /^[\u00F1\u00d1A-Za-z _]*[\u00F1\u00d1A-Za-z][\u00F1\u00d1A-Za-z _]*$/,
    "Please enter a valid first name."
  ),
  middle_name: Yup.string().trim().optional().nullable().matches(/^[\u00F1\u00d1A-Za-z _]*[\u00F1\u00d1A-Za-z][\u00F1\u00d1A-Za-z _]*$/,
    "Please enter a valid middle name."),
  last_name: Yup.string().trim().required("The last name field is required.").matches(
    /^[\u00F1\u00d1A-Za-z _]*[\u00F1\u00d1A-Za-z][\u00F1\u00d1A-Za-z _]*$/, "Please enter a valid last name."
  ),
  contact_no: Yup.number().required('The contact number field is required').test('phl_contactNo', 'Please check the length of the contact number', (value) => {
    const regex = /^\d{10}$/;
    return regex.test(value);
  }),
  email: Yup.string().email("Invalid email address.").required("The email field is required."),
  sex: Yup.string().trim().oneOf(['Male','Female','Non-Binary','Prefer not to say'],'That is not a available option for that').required('The sex field is required'),
  resume: Yup.object().required("The resume field is required."),
});

export const ServerJobApplicationSchema = Yup.object({
  first_name: Yup.string().trim().required("The first name field is required."),
  middle_name: Yup.string().trim().optional().nullable(),
  last_name: Yup.string().trim().required("The last name field is required."),
  contact_no: Yup.string().trim().required("The contact number field is required."),
  email: Yup.string().email("Invalid email address.").required("The email field is required."),
  sex: Yup.string().trim().oneOf(['Male','Female','Non-Binary','Prefer not to say'],'That is not a available option for that').required('The sex field is required'),
})
